export const colors = {
  primary: "#0063E2",
};
